import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DATE_RANGE_DEAULT_VALUES } from 'libs/nagel-consts/src/lib/fieldConsts';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from '../storageService/storage.service';
import { getEndOfDay, getStartOfDay } from '@nagel-utils';
import { DateRangeFormType } from 'libs/nagel-types/src/lib/field-types';

@Injectable({
    providedIn: 'root'
})
export class DateRangeFilterService {
    form!: FormGroup;
    currentDateRangeSubject: BehaviorSubject<DateRangeFormType> = new BehaviorSubject<DateRangeFormType>(DATE_RANGE_DEAULT_VALUES);
    currentDateRange$ = this.currentDateRangeSubject.asObservable();
    isMenuElement = false;

    constructor(
        private storageService: StorageService
    ) { }

    private getShouldExecuteValidation = () => {
        return !this.isMenuElement;
    };

    private getDateRangePickerProcessedValue = (value: DateRangeFormType): DateRangeFormType => {
        const result = structuredClone(value);

        if (result && !result?.startDate) {
            result.startDate = getStartOfDay(new Date());
            result.endDate =  getEndOfDay(new Date());
        }

        return result;
    };

    private getInitialData = (storageKey: string, value?: DateRangeFormType | null) => {
        return value
            ? this.getDateRangePickerProcessedValue(value)
            : this.getLocalStorageParsedData(storageKey) || DATE_RANGE_DEAULT_VALUES;
    };

    handleOnInit = (storageKey: string, isMenuElement: boolean = false, value?: DateRangeFormType | null) => {
        const dateRangePickerValue = this.getInitialData(storageKey, value);
        this.isMenuElement = isMenuElement;

        if (dateRangePickerValue) {
            const { startDate, endDate } = dateRangePickerValue;
            const formGroup = this.getForm();

            const parsedStartDate = new Date(startDate);
            const parsedEndDate = new Date(endDate);

            formGroup.patchValue({
                startDate: parsedStartDate,
                endDate: parsedEndDate
            });

            this.currentDateRangeSubject.next({
                startDate,
                endDate
            });
        }
    };

    handleOnDestroy = (storageKey: string) => {
        const formData = this.form && this.form.getRawValue();

        if (formData) {
            const parsedData = JSON.stringify(formData);

            if (!this.form.invalid) {
                this.storageService.saveItem(storageKey, parsedData);
            }
        }
    };

    setForm = (form: FormGroup) => {
        this.form = form;
    };

    getForm = () => {
        return this.form;
    };

    setErrors = (error: object | null) => {
        if (this.getShouldExecuteValidation()) {
            this.getForm()?.setErrors(error);
        }
    };

    getLocalStorageParsedData = (storageKey: string) => {
        const storageData = this.storageService.getItem(storageKey);

        return storageData ? JSON.parse(storageData) : null;
    };

    patchFormValues = (formValues: DateRangeFormType) => {
        const  { startDate, endDate } = formValues;

        this.form.patchValue({
            startDate,
            endDate
        });
    };
}
